import { useEffect } from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy({ t }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Privacy Policy Content */}
      <section className="privacy-policy">
        <div className="container">
          <div className="privacy-header">
            <h1 className="privacy-title">{t.privacy.title}</h1>
            <p className="privacy-date">{t.privacy.lastUpdated}</p>
          </div>

          <div className="privacy-content">
            {t.privacy.sections.map((section, index) => (
              <div key={index} className="privacy-section">
                <h2 className="privacy-section-title">
                  <span className="section-number">{index + 1}</span>
                  {section.title}
                </h2>
                <p className="privacy-section-text">{section.content}</p>
                {section.list && (
                  <ul className="privacy-list">
                    {section.list.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          <div className="privacy-back">
            <Link to="/" className="btn btn-primary">
              {t.privacy.backHome}
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-bottom">
            <p>{t.footer.rights}</p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default PrivacyPolicy;
